import React from 'react'
import styled from 'styled-components'

import MakerImg from '../../assets/images/makers-bg.webp'

import { usePageContext } from 'contexts/Page'
import { Box } from '../Box'
import { StreamLogo } from '../StreamLogo'
import { Heading, Text } from '../Text'
import { TextLink } from '../TextLink'

const Root = styled(Box)`
  padding: 2rem 1.5rem 2rem 1.5rem;
  z-index: 0;
  &:before {
    content: '';
    background-image: url(${({ image }) => image});
    background-position: top right;
    background-repeat: no-repeat;
    background-size: 50%;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: -1;
  }
`

const MakerCTA = () => {
  const { tutorial } = usePageContext()
  
  return (
    <a
      rel="noreferrer"
      target="_blank"
      href={`https://getstream.io/maker-account/?utm_campaign=${tutorial.event.utm_campaign}&utm_medium=${tutorial.event.utm_medium}&utm_source=${tutorial.event.utm_source}&utm_content=${tutorial.event.utm_content}`}
    >
      <Root image={MakerImg}>
        <StreamLogo size={1} />
        <Heading
          marginY={2}
          as="h4"
          fontSize={6}
          fontWeight="800"
          lineHeight={7}
        >
          Open Your
          <br /> Maker Account
        </Heading>
        <Text marginY={2} fontSize={2} lineHeight={4}>
          Get started building your project <br /> with Stream Chat & Activity
          Feeds.
        </Text>
        <TextLink marginTop={4}>Learn More</TextLink>
      </Root>
    </a>
  )
}

export default MakerCTA
